/**
 * Created by Ivan on 17.09.2023
 */

var ClearPiecesBooster = function (id) {
    Booster.call(this, id);
};

ClearPiecesBooster.prototype = Object.create(Booster.prototype);
ClearPiecesBooster.prototype.constructor = ClearPiecesBooster;

ClearPiecesBooster.prototype.isForceAvailable = function () {
    return Booster.prototype.isForceAvailable.call(this) && Game.currentGame.isBoosterForceEnabled();
};

ClearPiecesBooster.prototype.getControls = function () {
    return ["hint_21"];
};

ClearPiecesBooster.prototype.onExecute = function () {
    Game.currentGame.grid.runClearBang();
};